import React, { useState } from "react";
import {
    Paper,
    Grid,
    Typography,
    TextField,
    Button,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    FormControl,
    Select,
    MenuItem,
    IconButton
} from "@mui/material";
import { useHistory } from "react-router-dom";
import DeleteIcon from "@mui/icons-material/Delete";
import { toast } from "react-toastify";
import { createProcessRequest, getProcessRequest } from "../../globalhelper/helper";

const CreateProcess = () => {

    const history = useHistory();

    // Form State
    const [formData, setFormData] = useState({
        process_cd: "",
        process_name: "",
        short_text: "",
        data_type: "VARCHAR",
        mandatory: "null"
    });


    const [tableData, setTableData] = useState([]);

    const dataTypes = [
        "VARCHAR",
        "FLOAT",
        "INTEGER",
        "DATE",
        "DATETIME",
        "BOOLEAN"
    ];

    const dropdownOptions = [
        "null",
        "True"
    ];


    const handleChange = (event) => {

        const { name, value } = event.target;

        setFormData((prev) => ({
            ...prev,
            [name]: value
        }));
    };


    const handleRowChange = (
        index,
        field,
        value
    ) => {

        const updatedRows = [...tableData];

        updatedRows[index][field] = value;

        if (
            field === "short_text" ||
            field === "process_cd"
        ) {

            const processCd =
                field === "process_cd"
                    ? value.trim()
                    : updatedRows[index].process_cd?.trim();

            const shortText =
                field === "short_text"
                    ? value.trim()
                    : updatedRows[index].short_text?.trim();


            updatedRows[index].domain =
                shortText || "";

            // Generate only if values exist
            const generatedValue =
                processCd && shortText
                    ? `${processCd}_${shortText}`
                    : "";

            updatedRows[index].name = generatedValue;
            updatedRows[index].label = generatedValue;
            updatedRows[index].acronym = generatedValue;
        }

        setTableData(updatedRows);
    };

    // Delete Row
    const handleDelete = (index) => {

        const updated =
            tableData.filter(
                (_, i) => i !== index
            );

        setTableData(updated);
    };


    const getDuplicateShortTexts = () => {

        const values = tableData.map(row =>
            row.short_text?.trim()
        );

        return values.filter(
            (item, index) =>
                item &&
                values.indexOf(item) !== index
        );
    };


    const hasError = tableData.some(
        row => !row.short_text?.trim()
    );


    const handleGenerate = async () => {

        if (!formData.process_cd.trim()) {

            toast.error(
                "Process CD is required"
            );

            return;
        }

        if (!formData.process_name.trim()) {

            toast.error(
                "Process Name is required"
            );

            return;
        }

        if (!formData.short_text.trim()) {

            toast.error(
                "Short Text is required"
            );

            return;
        }

        try {

            const response =
                await getProcessRequest(
                    "api/process/getProcessCdList"
                );

            console.log(
                "PROCESS LIST:",
                response
            );

            const existingProcess =
                response?.data?.data?.find(
                    (item) =>
                        item.process_cd?.toLowerCase() ===
                        formData.process_cd?.toLowerCase()
                );

            if (existingProcess) {
                toast.error(
                    `Process Code ${formData.process_cd} already exists in DB`
                );

                return;
            }

            const shortTextList =
                formData.short_text
                    .split(/\s+/)
                    .map(item => item.trim())
                    .filter(item => item !== "");

            const generatedRows =
                shortTextList.map((shortText) => {

                    const generatedName =
                        `${formData.process_cd}_${shortText}`;

                    return {

                        process_cd:
                            formData.process_cd,

                        process_name:
                            formData.process_name,

                        short_text:
                            shortText,

                        domain:
                            shortText,

                        name:
                            generatedName,

                        label:
                            generatedName,

                        data_type:
                            formData.data_type || "VARCHAR",

                        default_value:
                            "null",

                        lde: 0,

                        indexing: 0,

                        group:
                            formData.group || "null",

                        mandatory:
                            formData.mandatory || "null",

                        derive_formula:
                            formData.derive_formula || "null",

                        predefined_list:
                            formData.predefined_list || "null",

                        acronym:
                            generatedName
                    };
                });

            setTableData((prev) => [
                ...prev,
                ...generatedRows
            ]);

            setFormData((prev) => ({
                ...prev,
                short_text: ""
            }));

            toast.success(
                "Rows generated successfully"
            );

        } catch (error) {

            toast.error(
                "Failed to validate Process Code"
            );
        }
    };

    const handleAddRow = () => {

        // Validation
        if (!formData.process_cd.trim()) {

            toast.error("Process CD is required");
            return;
        }

        if (!formData.process_name.trim()) {

            toast.error("Process Name is required");
            return;
        }

        const generatedName =
            `${formData.process_cd}_`;

        const newRow = {

            process_cd: formData.process_cd,
            process_name: formData.process_name,
            short_text: "",
            domain: "",
            name: generatedName,
            label: generatedName,
            data_type: "VARCHAR",
            default_value: "null",
            lde: 0,
            indexing: 0,
            group: "null",
            mandatory: "null",
            derive_formula: "null",
            predefined_list: "null",
            acronym: generatedName
        };

        setTableData((prev) => [
            ...prev,
            newRow
        ]);
    };

    // Save All
    const handleSaveAll = async () => {

        const hasEmpty = tableData.some(
            (row) => !row.short_text?.trim()
        );

        if (hasEmpty) {

            toast.error(
                "Short Text is required"
            );

            return;
        }

        const duplicates =
            getDuplicateShortTexts();

        if (duplicates.length > 0) {

            const uniqueDuplicates = [
                ...new Set(duplicates)
            ];

            toast.error(
                `Duplicate Short Text: ${uniqueDuplicates.join(", ")}`
            );

            return;
        }

        const finalTableData =
            tableData.map((row) => ({

                process_cd:
                    row.process_cd,

                process_name:
                    row.process_name,

                short_text:
                    row.short_text,

                domain:
                    row.domain,

                name:
                    row.name,

                label:
                    row.label,

                data_type:
                    row.data_type,

                default_value:
                    row.default_value,

                lde:
                    row.lde,

                indexing:
                    row.indexing,

                mandatory:
                    row.mandatory,

                derive_formula:
                    row.derive_formula,

                predefined_list:
                    row.predefined_list,

                acronym:
                    row.acronym

            }));

        console.log(
            "FINAL PAYLOAD:",
            finalTableData
        );

        try {

            const result =
                await createProcessRequest(
                    "api/process/createBulkProcess",
                    finalTableData
                );

            console.log(
                "SAVE RESULT:",
                result
            );

            if (!result?.data?.success) {

                toast.error(
                    result?.data?.message ||
                    "Failed to create process"
                );

                return;
            }

            toast.success(
                result?.data?.message ||
                "Process Created Successfully"
            );


            setTableData([]);

            setFormData({
                process_cd: "",
                process_name: "",
                short_text: "",
                data_type: "VARCHAR",
                mandatory: "null"
            });

        } catch (error) {

            console.log(
                "SAVE ERROR:",
                error
            );

            console.log(
                "ERROR RESPONSE:",
                error?.response
            );

            console.log(
                "ERROR DATA:",
                error?.response?.data
            );


            toast.error(
                error?.response?.data?.message ||
                error?.response?.data?.error ||
                "Failed to create process"
            );
        }
    };

    return (

        <Paper
            elevation={3}
            sx={{
                padding: "25px",
                margin: "20px"
            }}
        >

            {/* Header */}
            <Grid
                container
                justifyContent="space-between"
                alignItems="center"
                sx={{ marginBottom: "25px" }}
            >

                <Grid item>
                    <Typography variant="h5">
                        Create Process
                    </Typography>
                </Grid>

                <Grid item>

                    <Button
                        variant="outlined"
                        onClick={() => history.push("/process")}
                    >
                        Back
                    </Button>

                </Grid>

            </Grid>

            {/* Form Section */}

            <Paper
                elevation={2}
                sx={{
                    padding: "20px",
                    marginBottom: "25px"
                }}
            >

                <Grid container spacing={3}>

                    {/* Process CD */}
                    <Grid item xs={12} md={6}>

                        <TextField
                            fullWidth
                            label="Process CD"
                            name="process_cd"
                            value={formData.process_cd}
                            onChange={handleChange}
                        />

                    </Grid>

                    {/* Process Name */}
                    <Grid item xs={12} md={6}>

                        <TextField
                            fullWidth
                            label="Process Name"
                            name="process_name"
                            value={formData.process_name}
                            onChange={handleChange}
                        />

                    </Grid>

                    {/* Short Text */}
                    <Grid item xs={12}>

                        <TextField
                            fullWidth
                            multiline
                            rows={8}
                            label="Short Text"
                            name="short_text"
                            value={formData.short_text}
                            onChange={handleChange}
                            helperText="Paste values line by line OR space separated"
                        />

                    </Grid>

                    {/* Generate Button */}
                    <Grid item xs={12}>

                        <Button
                            variant="contained"
                            onClick={handleGenerate}
                        >
                            Generate Rows
                        </Button>

                    </Grid>

                </Grid>

            </Paper>

            {/* Table Section */}

            {tableData.length > 0 && (

                <Paper elevation={2}>

                    <div
                        style={{
                            width: "100%",
                            overflowX: "auto",
                            overflowY: "auto",
                            maxHeight: "500px"
                        }}
                    >

                        <TableContainer>

                            <Table
                                stickyHeader
                                sx={{
                                    minWidth: "1800px"
                                }}
                            >

                                <TableHead>

                                    <TableRow>
                                        <TableCell>Short Text</TableCell>
                                        <TableCell>Data Type</TableCell>
                                        <TableCell>Default Value</TableCell>
                                        <TableCell>LDE</TableCell>
                                        <TableCell>Indexing</TableCell>
                                        <TableCell>Mandatory</TableCell>
                                        <TableCell>Derive Formula</TableCell>
                                        <TableCell>Action</TableCell>
                                    </TableRow>

                                </TableHead>

                                <TableBody>

                                    {tableData.map((row, index) => (

                                        <TableRow key={index}>

                                            {/* Short Text */}
                                            <TableCell>

                                                <TextField
                                                    value={row.short_text}
                                                    error={!row.short_text?.trim()}
                                                    helperText={
                                                        !row.short_text?.trim()
                                                            ? "Short text is required"
                                                            : ""
                                                    }
                                                    onChange={(e) =>
                                                        handleRowChange(
                                                            index,
                                                            "short_text",
                                                            e.target.value
                                                        )
                                                    }
                                                    size="small"
                                                    sx={{
                                                        minWidth: "180px"
                                                    }}
                                                />

                                            </TableCell>

                                            {/* Data Type */}
                                            <TableCell>

                                                <FormControl
                                                    size="small"
                                                    sx={{ minWidth: "150px" }}
                                                >

                                                    <Select
                                                        value={row.data_type}
                                                        onChange={(e) =>
                                                            handleRowChange(
                                                                index,
                                                                "data_type",
                                                                e.target.value
                                                            )
                                                        }
                                                    >

                                                        {dataTypes.map((item) => (
                                                            <MenuItem
                                                                key={item}
                                                                value={item}
                                                            >
                                                                {item}
                                                            </MenuItem>
                                                        ))}

                                                    </Select>

                                                </FormControl>

                                            </TableCell>

                                            {/* Default Value */}
                                            <TableCell>

                                                <TextField
                                                    value={row.default_value}
                                                    onChange={(e) =>
                                                        handleRowChange(
                                                            index,
                                                            "default_value",
                                                            e.target.value
                                                        )
                                                    }
                                                    size="small"
                                                />

                                            </TableCell>

                                            {/* LDE */}
                                            <TableCell>

                                                <TextField
                                                    value={row.lde}
                                                    onChange={(e) =>
                                                        handleRowChange(
                                                            index,
                                                            "lde",
                                                            e.target.value
                                                        )
                                                    }
                                                    size="small"
                                                    sx={{ width: "80px" }}
                                                />

                                            </TableCell>

                                            {/* Indexing */}
                                            <TableCell>

                                                <TextField
                                                    value={row.indexing}
                                                    onChange={(e) =>
                                                        handleRowChange(
                                                            index,
                                                            "indexing",
                                                            e.target.value
                                                        )
                                                    }
                                                    size="small"
                                                    sx={{ width: "90px" }}
                                                />

                                            </TableCell>

                                            {/* Mandatory */}
                                            <TableCell>

                                                <FormControl
                                                    size="small"
                                                    sx={{ minWidth: "120px" }}
                                                >

                                                    <Select
                                                        value={row.mandatory}
                                                        onChange={(e) =>
                                                            handleRowChange(
                                                                index,
                                                                "mandatory",
                                                                e.target.value
                                                            )
                                                        }
                                                    >

                                                        {dropdownOptions.map((item) => (
                                                            <MenuItem
                                                                key={item}
                                                                value={item}
                                                            >
                                                                {item}
                                                            </MenuItem>
                                                        ))}

                                                    </Select>

                                                </FormControl>

                                            </TableCell>

                                            {/* Derive Formula */}
                                            <TableCell>

                                                <TextField
                                                    value={row.derive_formula || ""}
                                                    onChange={(e) =>
                                                        handleRowChange(
                                                            index,
                                                            "derive_formula",
                                                            e.target.value
                                                        )
                                                    }
                                                    size="small"
                                                    sx={{ minWidth: "160px" }}
                                                />

                                            </TableCell>

                                            {/* Action */}
                                            <TableCell>

                                                <IconButton
                                                    color="error"
                                                    onClick={() =>
                                                        handleDelete(index)
                                                    }
                                                >
                                                    <DeleteIcon />
                                                </IconButton>

                                            </TableCell>

                                        </TableRow>

                                    ))}

                                </TableBody>

                            </Table>

                        </TableContainer>

                    </div>

                    {/* Footer Buttons */}
                    <Grid
                        container
                        justifyContent="flex-end"
                        spacing={2}
                        sx={{ padding: "20px" }}
                    >

                        <Grid item>
                            <Button
                                variant="outlined"
                                onClick={handleAddRow}
                            >
                                + Add Row
                            </Button>
                        </Grid>

                        <Grid item>

                            <Button
                                variant="contained"
                                color="success"
                                disabled={hasError}
                                onClick={handleSaveAll}
                            >
                                Save All
                            </Button>

                        </Grid>

                    </Grid>

                </Paper>

            )}

        </Paper>
    );
};

export default CreateProcess;
